import { render, staticRenderFns } from "./ProductBundles.vue?vue&type=template&id=3f736f84&scoped=true"
import script from "./ProductBundles.vue?vue&type=script&lang=js"
export * from "./ProductBundles.vue?vue&type=script&lang=js"
import style0 from "./ProductBundles.vue?vue&type=style&index=0&id=3f736f84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f736f84",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fproduct-bundles%2FProductBundles.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports